/* Maniscreen — Main Product Offer Page JS
   Handles: gallery thumbnails | quantity +/- | accordion
   (Add to Bag submit/AJAX cart is handled by product-form.js)
*/

(function () {
  'use strict';

  document.querySelectorAll('.msn-pdp-offer').forEach(pdp => {
    const sectionId = pdp.dataset.sectionId;
    const mainImg   = pdp.querySelector(`#MsnMainImg-${sectionId}`);
    const thumbsWrap= pdp.querySelector(`#MsnThumbs-${sectionId}`);
    const qtyInput  = pdp.querySelector(`#MsnQty-${sectionId}`);

    /* ── Gallery thumbnails ────────────────────────── */
    if (thumbsWrap && mainImg) {
      thumbsWrap.querySelectorAll('.msn-pdp-offer__thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          const newSrc = thumb.dataset.mediaSrc;
          if (!newSrc) return;
          mainImg.classList.add('loading');
          const preload    = new Image();
          preload.onload   = () => { mainImg.src = newSrc; mainImg.classList.remove('loading'); };
          preload.onerror  = () => { mainImg.src = newSrc; mainImg.classList.remove('loading'); };
          preload.src      = newSrc;
          thumbsWrap.querySelectorAll('.msn-pdp-offer__thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    }

    /* ── Quantity +/- ──────────────────────────────── */
    pdp.querySelectorAll('.msn-pdp-offer__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const val = parseInt(qtyInput.value, 10) || 1;
        const min = parseInt(qtyInput.min,   10) || 1;
        const max = parseInt(qtyInput.max,   10) || 999;
        qtyInput.value = btn.dataset.action === 'inc'
          ? Math.min(val + 1, max)
          : Math.max(val - 1, min);
      });
    });

    /* ── Read more / less description ──────────────── */
    const descWrap   = pdp.querySelector('[data-msn-desc-wrap]');
    const descEl     = descWrap?.querySelector('[data-msn-desc]');
    const descToggle = descWrap?.querySelector('[data-msn-desc-toggle]');

    if (descEl && descToggle) {
      descEl.classList.add('is-clamped');
      requestAnimationFrame(() => {
        descToggle.hidden = descEl.scrollHeight <= descEl.clientHeight + 1;
      });

      descToggle.addEventListener('click', () => {
        const isExpanded = descToggle.getAttribute('aria-expanded') === 'true';
        descEl.classList.toggle('is-clamped', isExpanded);
        descToggle.setAttribute('aria-expanded', String(!isExpanded));
        descToggle.textContent = isExpanded
          ? descToggle.dataset.readMoreText
          : descToggle.dataset.readLessText;
      });
    }

    /* ── Accordion ─────────────────────────────────── */
    pdp.querySelectorAll('.msn-pdp-offer__acc-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isOpen  = trigger.getAttribute('aria-expanded') === 'true';
        const panelId = trigger.getAttribute('aria-controls');
        const panel   = pdp.querySelector(`#${panelId}`);

        pdp.querySelectorAll('.msn-pdp-offer__acc-trigger').forEach(t => {
          if (t !== trigger) {
            t.setAttribute('aria-expanded', 'false');
            const p = pdp.querySelector(`#${t.getAttribute('aria-controls')}`);
            if (p) p.hidden = true;
          }
        });
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });

  });

})();
